<script setup lang="ts">
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  title: string
  keyName: string
  modelValue: {
      [key: string]: boolean
  }[] | {
    [key: string]: boolean
  }
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <v-row class="text-form pr-3 pt-2">
    <v-col
      cols="2"
    >
      <h6 class="pt-2 pl-2">
        {{ props.title }}
      </h6>
    </v-col>
    <v-col
      cols="10"
      class="d-flex"
      style="position: relative"
    >
      <template
        v-for="(bool, key) in modelValue"
        :key="key"
      >
          <div class="col-1 pt-2">
            <h6>
              {{ i18n.global.t(`pages.accounts.form.notificationSettings.${keyName}.${key}`) }}
            </h6>
          </div>
          <div class="col-2">
            <ToggleSwitch
              v-model="modelValue[key]"
            />
          </div>
      </template>
    </v-col>
  </v-row>
</template>
